const base64toblob = require("base64toblob")

export default (_ctx, inject) => {
	inject('base64toblob', base64toblob)
}

// Do not remove this file, it is used in so many pages
// Using it improve a lot of build sizes